import { ContentType } from '@trellis/api'
import type { RequestResult } from '@trellis/shared'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export interface SendQuoteBody {
  to?: string
  subject?: string
  message?: string
  force?: boolean
}

export interface SendQuoteResult {
  sentAt: string
}

export const sendQuote = (
  id: string,
  body: SendQuoteBody,
): Promise<RequestResult<SendQuoteResult>> =>
  request<SendQuoteResult>(() =>
    apiClient.api.request({
      path: `/api/quotes/${id}/send`,
      method: 'POST',
      body,
      type: ContentType.Json,
      format: 'json',
    }),
  )
